angular.module("sede.components", []).component("sede", {
  templateUrl: "ng/components/sede/sede.view.html",
  bindings: {
    title: "@",
    model: "=",
    disabled: "<",
    changes: "&",
    disableIfOk: "<",
    initialTabIndex: "<",
    allowForeign: "@",
    clientIdentifier: "<",
    pickNsilAddress: "<",
    addImmoInfo: "<",
    digital: "=",
    ndg: "=",
    exportValiditySede: "&",
    changeStatus: "<",
    notCheckValidation: '<',
    nations: '<'
  },
  controllerAs: "sedeCtrl",
  controller: function (
    $userService,
    $rootScope,
    Sede,
    $modalService,
    $timeout,
    $istatService,
    $uniService,
    $scope
  ) {
    $scope.forms = {};
    /** not to loose *this reference **/
    var initProvince = function () {
      self.supportModel.dropdown.province = $rootScope.comuniMap && $rootScope.comuniMap
        .map(function (comune) {
          return comune.sigla;
        })
        .filter(function (siglaComune) {
          return siglaComune != "";
        })
        .sort()
        .reduce(function (result, nextItem) {
          return result.includes(nextItem) ? result : result.concat(nextItem);
        }, []);
    };

    var self = this;

    self.$userService = $userService;

    self.supportModel = {
      newAddressSelected: null,
      visible: false,
      formTitle: "",
      initialIndex: 0,
      populated: false,
      foreignNationPicked: false,
      digital: "",
      ndg: "",
      dropdown: {
        nations: [],
        province: [],
        comuni: [],
        caps: [],
        typeStreet: []
      }
    };


    self.$onInit = function () {
      self.model = Sede.build(self.model);
      $scope.forms.sede = "Form_" + self.title.split(" ").join("_");
      self.supportModel.formTitle = "Form_" + self.title.split(" ").join("_");
      if (self.model) {
        if (self.model.comune && self.model.comune.nome) {
          self.model.luogoEsteso.nome = self.model.comune.nome;
        } else {
          self.model.luogoEsteso.nome = self.model.comune;
        }
        self.model.luogoEsteso.sigla = self.model.provincia;
        self.model.luogoEsteso.cap = [self.model.cap];
      }
      if (self.model && !self.model.numeroCivico && self.digital == 'appFromCerved') {
        self.model.numeroCivico = "SNC"
      }

      self.model = Sede.build(Object.assign({}, self.model));


      self.modelloCostante = Object.assign({}, self.model);


      if (self.disableIfOk && self.model.isOk()) {
        self.supportModel.populated = true;
      }
      self.supportModel.initialIndex = self.initialTabIndex || 0;

      self.changes({
        name: self.supportModel.formTitle,
        model: self.model
      });

      initProvince();
      getTypeStreet();
      if (self.model.stato.name && self.model.stato.name.toUpperCase() != 'ITALIA') {
        self.supportModel.foreignNationPicked = true;
      } else {
        self.supportModel.foreignNationPicked = false;
      }
      self.supportModel.dropdown.nations = self.nations || $rootScope.nazioniEstere;//.filter(n => n.name.toUpperCase() == 'ITALIA');
      // if (self.allowForeign == "true") {
      //   getNations();
      // }

      self.supportModel.digital = self.digital;
      self.supportModel.ndg = self.ndg;

      if (self.model.provincia != null && typeof self.model.provincia != "undefined" && self.model.provincia != '') {
        self.getComuni(self.model.provincia);
      }

      if (self.model.provincia != null && typeof self.model.provincia != "undefined" && self.model.provincia != '' && self.model.luogoEsteso && self.model.luogoEsteso.nome) {
        self.getCaps(self.model.luogoEsteso)
      }

      $timeout(function () {
        $scope.forms &&
          $scope.forms.sede &&
          self.validitySede($scope.forms.sede.$valid)
      }, 800)

      self.errorIndirizzo = false;
    };

    self.$onChanges = function (changed) {
      if (changed.clientIdentifier &&
        typeof changed.clientIdentifier.currentValue != "undefined"
      ) {
        self.clientIdentifier = changed.clientIdentifier.currentValue;
      }

      if (changed.changeStatus && typeof changed.changeStatus.currentValue != "undefined") {
        $timeout(function () {
          self.validitySede($scope.forms.sede.$valid)
        }, 800)

      }
    };

    //onChange sulle province
    self.getCaps = function (comune) {
      var found = comune.cap;
      self.supportModel.dropdown.caps = found || [];
    };

    self.onChanges = function (name, value) {
      if (!name && !value) return;

      self.model[name] = value;

      //Allo sbiancamento di certi campi, ne sbianco altri
      switch (name) {
        case "provincia":
          self.model = Sede.build({
            stato: self.model.stato,
            provincia: value,
            indirizzoCerved: self.model.indirizzoCerved
          })
          self.model.luogoEsteso = "";
          break;

        case "stato": {
          if (value.name.toUpperCase() != 'ITALIA') {
            self.supportModel.foreignNationPicked = true;
            self.model.cap = "99999";
            self.model = Sede.build({
              stato: value,
              provincia: !self.supportModel.foreignNationPicked ? "" : "EE",
              indirizzoCerved: self.model.indirizzoCerved,
              cap: self.model.cap
            })
          } else {
            self.supportModel.foreignNationPicked = false;
            self.model = Sede.build({
              stato: value,
              provincia: !self.supportModel.foreignNationPicked ? "" : "EE",
              indirizzoCerved: self.model.indirizzoCerved
            })
          }
          break;
        }
        case "comune":
          if (self.supportModel.foreignNationPicked) {
            self.model = Sede.build({
              stato: self.model.stato,
              provincia: self.model.provincia,
              comune: self.supportModel.foreignNationPicked ? self.model.comune : self.model.luogoEsteso.nome,
              luogoEsteso: self.model.luogoEsteso,
              indirizzoCerved: self.model.indirizzoCerved,
              cap: self.model.cap
            })

          } else {

            self.model = Sede.build({
              stato: self.model.stato,
              provincia: self.model.provincia,
              comune: self.supportModel.foreignNationPicked ? self.model.comune : self.model.luogoEsteso.nome,
              luogoEsteso: self.model.luogoEsteso,
              indirizzoCerved: self.model.indirizzoCerved
            })
          }
          break;
        case "numeroCivico":
        case "scala":
        case "piano":
        case "interno":
          self.model[name] = value;
          break;
        case "indirizzo":
          self.model.indirizzo = value;
          if (self.model && self.model.indirizzo && self.model.indirizzo.length > 30) {
            self.errorIndirizzo = true;
          } else {
            self.errorIndirizzo = false;
          }
          break;
        default:
          break;
      }

      self.validitySede($scope.forms.sede.$valid);

      checkAddressModify();
      //Rifletto il cambiamento
      self.changes({
        name: self.supportModel.formTitle,
        model: self.model
      });
    };

    self.getComuni = function (provincia) {
      self.supportModel.dropdown.comuni = $rootScope.comuniMap
        .filter(function (comune) {
          return comune.sigla == provincia;
        });
    };

    var getNations = function () {
      $istatService.getNazioni()
        .then(function (response) {

          self.supportModel.dropdown.nations = response.domainList.filter(
            function (element) {
              return !element.deleted
            });
        })
    };

    self.openAddressModal = function () {
      self.supportModel.visible = true;
      $timeout(function () {
        $(".financial-leasing__footer").css("z-index", "-1");
        $('.mCSB_scrollTools').css("z-index", "-2");
        $modalService.openModal('nsil-address-modal');
      }, 500)


    }

    self.closeAddressModal = function () {
      $modalService.closeModal('nsil-address-modal');
      $(".financial-leasing__footer").css("z-index", "2");
      $('.mCSB_scrollTools').css("z-index", "2");
      self.supportModel.visible = false;

    }

    self.onAddressPicked = function (address) {
      self.model = Object.assign({}, Sede.build(address));

      //Rifletto il cambiamento
      self.changes({
        name: self.supportModel.formTitle,
        model: address
      });

      self.closeAddressModal();
    }

    self.validitySede = function (validity) {
      self.exportValiditySede({
        validity
      })
    }

    var checkAddressModify = function () {
      var check = true;
      for (var key in self.model) {
        if (key == 'stato' ||
          key == 'provincia' ||
          key == 'comune' ||
          key == 'luogoEsteso' ||
          key == 'cap' ||
          key == 'indirizzo' ||
          key == 'numeroCivico') {

          if (key == 'stato') {
            for (var internalKey in self.model[key]) {
              if (self.model[key][internalKey] != self.modelloCostante[key][internalKey]) {
                check = false;
              }
            }
          } else if (key == 'luogoEsteso') {
            for (var internalKey in self.model[key]) {
              if (internalKey != 'cap' && internalKey != 'codiceCatastale' && self.model[key][internalKey] != self.modelloCostante[key][internalKey]) {
                check = false;
              }
            }
            //se il comune è un oggetto
          } else if (key === 'comune' && self.model && self.model[key] && self.model[key].nome) {
            if (self.model[key].nome && self.modelloCostante[key].nome && self.model[key].nome.toUpperCase() != self.modelloCostante[key].nome.toUpperCase()) {
              check = false;
            }
          } else if (!self.model[key] && self.modelloCostante[key]) {
            check = false;
          } else {
            if (self.model[key] && self.modelloCostante[key] && self.model[key].toUpperCase() != self.modelloCostante[key].toUpperCase()) {
              check = false;
            }
          }
        }
      }
      if (!check) {
        self.model.idNsil = null;
      } else {
        self.model.idNsil = self.modelloCostante.idNsil;
      }
    }

    var getTypeStreet = function () {
      $uniService.streetype()
        .then(function (response) {
          self.supportModel.dropdown.typeStreet = response.domainList
          // .map(function (element) {
          //   return element.value
          // })
          // .reduce(function (result, nextItem) {
          //   return result.includes(nextItem) ? result : result.concat(nextItem);
          // }, []);
        })

    }

  }
});